<template>
  <div
    class="modal fade"
    id="showScoreDesc"
    tabindex="-1"
    role="dialog"
    aria-labelledby="showScoreDescLabel"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span
              aria-hidden="true"
            >&times;</span>
          </button>
          <h4
            class="modal-title"
            id="showScoreDescLabel"
          >
            {{ $t('string.scoreDescription') }}
          </h4>
        </div>
        <div class="modal-body">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>{{ $t('table.criteria') }}</th>
                <th>{{ $t('table.value') }}</th>
                <th>{{ $t('table.score') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(criteria, key) in scoreDescription"
                :key="key"
              >
                <td>{{ criteria.criteria.name_en }}</td>
                <td>{{ criteria.value || 'N/A' }}</td>
                <td>
                  <template v-if="criteria.score">
                    {{ criteria.score.score || 0 }}
                  </template>
                  <template v-else>
                    {{ $t('string.na') }}
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            <h3 class="text-right">
              {{ $t('table.score') }}: {{ scores }}
            </h3>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-default"
            data-dismiss="modal"
          >
            {{ $t('button.close') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ShowScoreDescriptionModal',
  computed: {
    ...mapState({
      scoreDescription: state => state.profileScoring.scoreDescription
    }),
    scores () {
      if (this.scoreDescription && Array.isArray(this.scoreDescription) && this.scoreDescription.length > 0) {
        const scores = this.scoreDescription.map(item => item.score || {})
        if (scores && Array.isArray(scores) && scores.length > 0) {
          const total_score = scores.map(item => item.score || 0).reduce((prev, curr) => parseFloat(prev) + parseFloat(curr))
          return parseFloat(total_score).toFixed(4)
        }
      }
      return 0
    }
  }
}
</script>

<style scoped>

</style>
